import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ScrollToTop from './components/ScrollToTop';
import initFacebookPixel from "./utils/facebookPixel";
import SEOManager from './components/SEOManager';
import BackOfficeFooter from './components/BackOfficeFooter';

import Menu from './pages/Menu';
import NewHome from './pages/NewHome';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Restaurant from './pages/Restaurant';
import Products from './pages/Products';
import Categories from './pages/Categories';
import NewProduct from './pages/NewProduct';
import NewCategory from './pages/NewCategory';
import Informations from './pages/Informations';
import Product from './pages/Product';
import Category from './pages/Category';
import NewRestaurant from './pages/NewRestaurant';
import Terms from './pages/Terms';
import CGU from './pages/CGU';
import CGV from './pages/CGV';
import Cookies from './pages/Cookies';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Blog from './pages/Blog';
import Article from './pages/Article';
import Pricing from './pages/Pricing';
import Orders from './pages/Orders';
import UserInformations from './pages/UserInformations';
import OrderManagement from './pages/OrderManagement';
import OrderTracking from './pages/OrderTracking';
import OrdersHistory from './pages/OrdersHistory';
import PaymentSettings from './pages/PaymentSettings';

function App() {
  useEffect(() => {
    initFacebookPixel();
  }, []);

  if (process.env.NODE_ENV === 'production') {
    console.log = function () {};
  }

  return (
    <AuthProvider>
      <div style={{ width: '100%' }}>
        <Router>
          <ScrollToTop />
          <SEOManager />
          <Routes>
            <Route path="/shop/:id/menu" element={<Menu />} />
            <Route path="/" element={<NewHome />} />
            <Route path="/legal-notice" element={<Terms />} />
            <Route path="/terms-of-service" element={<CGU/>} />
            <Route path="/terms-of-sale" element={<CGV/>} />
            <Route path="/cookie-policy" element={<Cookies/>} />
            <Route path="/privacy-policy" element={<PrivacyPolicy/>} />


            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<Article />} />
            <Route path="/pricing" element={<Pricing />} />


              <Route path="/login" element={<Login />} />

            {/* Pages clients authentifiées — sans footer */}
            <Route element={<PrivateRoute />}>
              <Route path="/orders" element={<Orders />} />
              <Route path="/orders/:id" element={<OrderTracking />} />
              <Route path="/settings" element={<UserInformations />} />
            </Route>

            {/* Pages back-office marchands — avec footer aide */}
            <Route element={<MerchantRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/new-shop" element={<NewRestaurant />} />
              <Route path="/shop/:id" element={<Restaurant />} />
              <Route path="/shop/:id/products" element={<Products />} />
              <Route path="/shop/:id/categories" element={<Categories />} />
              <Route path="/shop/:id/products/new" element={<NewProduct />} />
              <Route path="/shop/:id/categories/new" element={<NewCategory />} />
              <Route path="/shop/:id/informations" element={<Informations />} />
              <Route path="/shop/:id/products/:id" element={<Product />} />
              <Route path="/shop/:id/categories/:id" element={<Category />} />
              <Route path="/shop/:id/orders" element={<OrderManagement />} />
              <Route path="/shop/:id/orders-history" element={<OrdersHistory />} />
              <Route path="/shop/:id/payment-settings" element={<PaymentSettings />} />
            </Route>

            <Route path="*" element={<NewHome />} />
          </Routes>
        </Router>
      </div>
    </AuthProvider>
  );
}

export default App;

const PrivateRoute = () => {
  const { currentUser, authReady } = useAuth();

  if (!authReady) return null;

  return currentUser ? <Outlet /> : <Navigate to="/" replace />;
};

const MerchantRoute = () => {
  const { currentUser, authReady } = useAuth();

  if (!authReady) return null;

  return currentUser ? (
    <>
      <Outlet />
      <BackOfficeFooter />
    </>
  ) : <Navigate to="/" replace />;
};



